import { render } from "./WmsPickScreen.vue?vue&type=template&id=c70ce5fa&scoped=true"
import script from "./WmsPickScreen.vue?vue&type=script&lang=js"
export * from "./WmsPickScreen.vue?vue&type=script&lang=js"

import "./WmsPickScreen.vue?vue&type=style&index=0&id=c70ce5fa&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c70ce5fa"]])

export default __exports__